<template>
  <div class="show-capsule-titlebar-container">
    <div class="titlebar-avatar">
      <div class="titlebar-image">
        <img class="rounded-circle" :src="currentCapsule.stylist_avatar_url" />
      </div>
      <div class="titlebar-stylist">{{ currentCapsule.stylist_username }}</div>
      <div class="titlebar-published-date">{{ formattedPublishedOnDate }}</div>
    </div>
    <div class="titlebar-details">
      <div class="titlebar-title">{{ currentCapsule.title }}</div>
      <div class="titlebar-occasion">{{ currentCapsule.occasion }}</div>
    </div>
    <div class="titlebar-notes">
      <div v-show="currentCapsule.notes">{{ currentCapsule.notes }}</div>
      <div v-show="currentCapsule.link" class="notes-link-wrapper">
        <i class="pe-7s-link"></i>
        <a
          class="notes-link"
          :href="currentCapsule.link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ currentCapsule.link }}
        </a>
      </div>
    </div>
    <div class="titlebar-stats">
      <div class="stats-sm d-block d-sm-none">
        <span>
          <span class="titlebar-stats-number">{{
            currentCapsule.products_count
          }}</span>
          items
        </span>
        <span class="pl-4">
          <span class="titlebar-stats-number">{{ outfitCount }}</span> outfits
        </span>
      </div>

      <div class="stats-lg d-none d-sm-block">
        <div class="stats">
          <div class="stack stack1" @click="scrollToElement('outfitTitleBar')">
            <div class="stack-number">
              {{ currentCapsule.products_count }}
            </div>
            <div class="stack-title">Items</div>
          </div>

          <div class="stack stack2" @click="scrollToElement('tabsSection')">
            <div class="stack-number">{{ outfitCount }}</div>
            <div class="stack-title">Outfits</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/showCapsule/Avatar.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Avatar,
  },

  data() {
    return {
      readMore: false,
    };
  },

  methods: {
    toggleNotes() {
      this.readMore = !this.readMore;
    },

    scrollToElement(elementRef) {
      this.$parent.$refs[elementRef].scrollIntoView(true);
    },
  },

  computed: {
    ...mapGetters(["currentCapsule", "capsuleOutfits"]),

    outfitCount() {
      return this.capsuleOutfits.length;
    },

    notesToggleText() {
      return this.readMore ? "Hide" : "Show";
    },

    formattedPublishedOnDate() {
      /*
        TODO: Displaying time
          - If less than 7 days show "6 days ago", etc, else show date as below
          - Make this time relative to a users current timezone
      */
      return this.$moment(this.currentCapsule.published_on).fromNow();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.show-capsule-titlebar-container {
  display: grid;
  gap: 15px 30px;
  grid-template-columns: auto minmax(0, 1fr);
  grid-template-areas:
    "avatar details details"
    "avatar stats stats"
    "notes notes notes";
  text-decoration: none;
  min-height: 50px;
  height: 100%;
  font-weight: 300;
  text-transform: none;

  @include for-tablet-portrait-up {
    padding: 15px 0 15px 15px;
    max-width: 100%;
    gap: 0px 50px;
    grid-template-areas:
      "avatar details details"
      "avatar notes stats";
  }

  .titlebar-avatar {
    grid-area: avatar;
    text-align: center;

    .titlebar-image > img {
      width: 80px;
      height: 80px;
    }

    .titlebar-stylist {
      padding-top: 15px;
      letter-spacing: 1.4px;
      font-size: 12px;
      font-weight: 400;
    }
    .titlebar-published-date {
      font-size: 11px;
      font-weight: 400;
      color: $grey3;
    }
  }

  .titlebar-details {
    grid-area: details;

    @include for-tablet-portrait-up {
      padding-left: 0px;
    }

    .titlebar-title {
      font-size: 26px;
      line-height: 32px;
    }

    .titlebar-occasion {
      padding-top: 3px;
      padding-bottom: 15px;
      letter-spacing: 1.4px;
      line-height: 24px;
      font-weight: 400;
      font-size: 11px;
      text-transform: uppercase;
      color: $grey3;
    }
  }

  .titlebar-notes {
    grid-area: notes;
    font-size: 14px;
    color: $grey1;
    padding-right: 0;
    padding-left: 0;

    @include for-tablet-portrait-up {
      padding-right: 0;
      padding-left: 0;
    }
    @include for-desktop-up {
      max-width: 65%;
    }

    .notes-link-wrapper {
      margin-top: 15px;

      .notes-link {
        padding-left: 5px;
        text-decoration: none;
        color: $mint-bright;

        &:hover {
          color: darken($mint-bright, 5%);
        }
      }
    }
  }
}

.titlebar-stats {
  grid-area: stats;

  .stats-sm {
    padding-bottom: 15px;
    font-size: 14px;
    line-height: 20px;

    .titlebar-stats-number {
      font-weight: 400;
    }
  }

  .stats {
    display: flex;
    justify-content: flex-end;
    flex-direction: row;

    .stack {
      cursor: pointer;
      text-align: center;

      &:not(:first-child) {
        padding-left: 30px;
      }
      &:not(:last-child) {
        padding-right: 30px;
        border-right: 1px solid $grey5;
      }

      .stack-number {
        color: $mint-bright;
        font-size: 26px;
        line-height: 32px;
      }
      .stack-title {
        letter-spacing: 1.4px;
        line-height: 24px;
        font-weight: 400;
        font-size: 11px;
        text-transform: uppercase;
        color: $grey1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/showCapsule/TitleBar.vue